<template>
	<script type="text/x-template" id="template-smart-warmth" class="template">
		<li class="block edit_block smart-warmth-block adjustment-block disabled">
			<div class="header-container edit_block_header drag_handle">
				<label class="lookup_block_name name">Smart Warmth</label>
			</div>

			<div class="block_options">
				<div class="block-sliders-container">
					<span class="slider-name">Opacity</span>
					<input
						type="range"
						min="0"
						max="100"
						data-default-value="50"
						value="50"
						step="1"
						data-pass-index="0"
						class="range_slider adjustmentBlock-slider"
					/>
					<input
						type="number"
						min="0"
						max="100"
						data-default-value="50"
						value="50"
						data-pass-index="0"
						class="range_value adjustmentBlock-range"
					/>
				</div>
			</div>
		</li>
	</script>
</template>

<script>
export default {};
</script>

<style></style>
